import React from 'react';
import {useTranslation} from "react-i18next";
import './CharacterCardFragment2.css'


function CharacterCardFragment2(props){
    const characters = props.characters || [];
    const { t, i18n } = useTranslation();

    function spriteStyle(id, size = 70) {
        const CELL = 70;
        const COLS = 10;
        const SPRITE_W = COLS * CELL;      // 700
        const SPRITE_H = 5 * CELL;         // 350
        const index = parseInt(id, 10) - 1;
        const col = index % COLS;
        const row = Math.floor(index / COLS);
        const scale = size / CELL;

        return {
            width: `${size}px`,
            height: `${size}px`,
            border: '1px solid white',
            backgroundImage: "url('/data/sprite.png')",
            backgroundSize: `${SPRITE_W * scale}px ${SPRITE_H * scale}px`,
            backgroundPosition: `-${col * CELL * scale}px -${row * CELL * scale}px`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '50%',
            imageRendering: 'auto',
            minWidth: `${size}px`
        };
    }


    //verifica la posizione di un'immagine nello sprite
    function getPosition(id) {
        const number = parseInt(id)
        const spriteWidth = 700; // Larghezza totale dello sprite
        const imageSize = 70; // Dimensione di ogni immagine (70x70)
        const imagesPerRow = spriteWidth / imageSize; // Numero di immagini per riga

        let x = ((number % imagesPerRow)===0)? (spriteWidth-70) : ((number % imagesPerRow) * imageSize)-70; // Calcola la posizione orizzontale
        const y = Math.floor((number-1) / imagesPerRow) * imageSize; // Calcola la posizione verticale

        return `-${x}px -${y}px`; // Restituisci le coordinate come stringa
    }
    return (
        <>
        <div className="character-card-fragment">
            <div style={{
            }}>
              {characters.map((character, index) => {
                return (
                    <div
                        key={index}
                        className={"interviewee-list"}
                        style={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "anchor-center"
                        }}
                        // onClick={(e) => handleCharacterClick(e, character.id)}
                        title={t('homePage.filterByCharacter')}
                    >
                        <div
                            className="interviewee-image"
                            style={spriteStyle(character.id, 20)}
                        >
                        </div>
                        <div className="interviewee-name-home list">{character.name}</div>

                    </div>
                );
              })}
            </div>
        </div>
        </>
    );
}

export default CharacterCardFragment2